import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

export const ADOT_QUANTITY_DECIMALS = 4;

export const roundADOTQuantity = (value: number | string): number =>
  Number(Number(value).toFixed(ADOT_QUANTITY_DECIMALS));

export const toADOTPositiveQuantity = (value: number | string): number => {
  const rounded = Math.abs(roundADOTQuantity(value));
  return rounded > 0 ? rounded : null;
};

export const toADOTQuantity = (value: number | string): number => {
  if (isNilOrEmpty(value)) {
    return null;
  }

  const rounded = Math.abs(roundADOTQuantity(value));
  return Number.isNaN(rounded) ? null : rounded;
};

export const exceedsADOTStock = (
  stock: number,
  quantity: number | string,
): boolean => roundADOTQuantity(Number(stock) - Number(quantity)) < 0;
